import {gsap, Quart} from "gsap";

import TemplateContents from './TemplateContents';
import Loading from './Loading';
import Transition from './Transition';
import Header from './Header';
import Footer from './Footer';

import Top from './Top';
import Page404 from "./Page404";
import VoicesSingle from "./VoicesSingle";
import VoicesArchive from "./VoicesArchive";
import Requirements from "./Requirements";
import Entry from "./Entry";
import Faq from "./Faq";
import Culture from "./Culture";
import Message from "./Message";
import LowerEntryMask from "./LowerEntryMask";

export default class extends TemplateContents{
    constructor(param){
        super(param);

        this.pack.common = this;
        // this.pack.barba = new BarbaCustom();

        this.bindloadCompletedHandler = this.loadCompletedHandler.bind(this);
        this.bindloadedBGWallHandler = this.loadedBGWallHandler.bind(this);
        this.pack.loading = new Loading();
        this.pack.loading.addEventListener('loadCompleted', this.bindloadCompletedHandler);
        this.pack.loading.addEventListener('loadedBGWall', this.bindloadedBGWallHandler);
    }

    init() {
        super.init();

        if (history.scrollRestoration) {
            history.scrollRestoration = 'manual';
        }
    }

    addScrollTarget(target){
        this.scrollTarget = target;
    }

    removeScrollTarget(){
        this.scrollTarget = undefined;
    }

    addEnterframeTarget(target){
        this.enterframeTarget = target;
    }

    removeEnterframeTarget(){
        this.enterframeTarget = undefined;
    }

    setVars(){
        super.setVars();
        this.enterframeID;
        this.enterframeIgnoreCnt = 0;

        this.pastPageYOffset = 0;
        this.scrollYOffset = 0;
        this.pastScrollYOffset = 0;

        this.UPDATE_LOAD_COEFF = 0.5;
        this.FPS = 30;
        this.targetInterval = 1000 / this.FPS;
        this.prevTime = Date.now() - this.targetInterval;

        this.isPc = undefined;
        this.fixedEntryIsSmall = false;
        this.fixedEntryFadingTimer = null;
        this.fixedEntrySmallThreshold = 80;
    }

    setDom(){
        super.setDom();
        this.scrollWrapper = document.querySelector('.scroll-wrapper');
        // this.barbaWrapper = document.querySelector('.barba-wrapper');
        this.barbaContainer = document.querySelector('.barba-container');
    }

    initEvents(){
        super.initEvents();

        this.resizeEvent = navigator.userAgent.match(/(iPhone|iPod|iPad)/) ? 'orientationchange' : 'resize';

        // window.addEventListener("load", this.loadedHandler.bind(this));
        window.addEventListener("DOMContentLoaded", this.DOMContentloadedHandler.bind(this));

        window.addEventListener(this.resizeEvent, this.resizeHandler.bind(this), false);
        window.addEventListener('scroll', this.scrollHandler.bind(this),{passive: false});

        this.resizeHandler();
        this.enterframe();
    }

    DOMContentloadedHandler(event){
        this.pack.loading.start();

        document.body.style.opacity = 1;
    }

/*
    loadedHandler(event){

    }
*/

    loadedBGWallHandler(event){
        // trace('loadedBGWallHandler');
        let namespace = this.barbaContainer.dataset.namespace;
        if (namespace === 'top') {
            this.pack.top = new Top();
        }
    }

    loadCompletedHandler(event){
        this.pack.loading.removeEventListener('loadCompleted', this.bindloadCompletedHandler);
        this.initContainer();
    }

    initContainer() {
        let hasRequirementsTarget = false;
        try {
            const searchParams = new URLSearchParams(window.location.search || '');
            hasRequirementsTarget = Boolean(searchParams.get('tab') || searchParams.get('requirement') || searchParams.get('requirement_id'));
        } catch (error) {
            hasRequirementsTarget = false;
        }

        if (!window.location.hash && !hasRequirementsTarget) {
            window.scrollTo(0, 0);
        }

        let namespace = this.barbaContainer.dataset.namespace;
        this.pack.current = namespace;

        this.pack.header = new Header();
        this.pack.footer = new Footer();
        this.pack.header.start();
        this.pack.footer.start();

        this.pack.transition = new Transition();

        if (namespace === 'top') {
            this.pack.top.start(true);
        }else if(namespace === 'voices'){
            this.pack.voicesArchive = new VoicesArchive();
            this.pack.voicesArchive.start();
        }else if(namespace === 'page404'){
            this.pack.page404 = new Page404();
            this.pack.page404.start(true);
        }else if(namespace === 'voices-single'){
            this.pack.voicesSingle = new VoicesSingle();
            this.pack.voicesSingle.start();
        }else if(namespace === 'requirements'){
            this.pack.requirements = new Requirements();
            this.pack.requirements.start();
        }else if(namespace === 'entry'){
            this.pack.entry = new Entry();
            this.pack.entry.start();
        }else if(namespace === 'faq'){
            this.pack.faq = new Faq();
            this.pack.faq.start();
        }else if(namespace === 'culture'){
            this.pack.culture = new Culture();
            this.pack.culture.start(true);
        }else if(namespace === 'message'){
            this.pack.message = new Message();
            this.pack.message.start(true);
        }

        if(namespace === 'top'){
            this.pack.footer.setFooter(true);
        }else{
            this.pack.footer.setFooter(false);
            document.documentElement.classList.remove('lock');
        }

        this.setCurrent();
    }

    setCurrent(){
        // this.pack.header.setCurrent();
        this.setupLowerEntryMask();
        this.updateFixedEntryButton(true);
    }

    clearLowerEntryMask(){
        if(!this.pack.lowerEntryMask) return;

        if(this.pack.lowerEntryMask.destructAfterContentsOut){
            this.pack.lowerEntryMask.destructAfterContentsOut();
        }

        if(this.pack.lowerEntryMask.destruct){
            this.pack.lowerEntryMask.destruct();
        }

        this.pack.lowerEntryMask = null;
    }

    setupLowerEntryMask(){
        this.clearLowerEntryMask();

        const sectionEntryDOM = document.querySelector('.section-entry .mask_target video');
        if(!sectionEntryDOM) return;

        this.pack.lowerEntryMask = new LowerEntryMask();
        this.pack.lowerEntryMask.start();
    }

    start(){

    }

    startTransitionIn(callback, scope){
        // let patern = (this.pack.current === 'top') ? 2 : 1;
        // this.pack.transition.setThreeD();
        this.pack.transition.transitIn(callback, scope);

    }

    startTransitionOut(){
        this.pack.transition.transitOut();
    }

    resetScrollY(){
        this.pack.scrollY = 0;
    }

    scrollHandler(){
        this.pack.scrollY = window.scrollY;
        if (this.scrollTarget) this.scrollTarget.scrollHandler();
        this.updateFixedEntryButton();
    }

    enterframe(){
        this.enterframeID = window.requestAnimationFrame(this.enterframe.bind(this));

        if(this.enterframeTarget && this.enterframeTarget.enterframe) this.enterframeTarget.enterframe();

        // this.smoothScroll();

        let currentTime = Date.now();
        let updated = false;
        while (currentTime - this.prevTime > this.targetInterval) {

            updated = true;
            this.prevTime += this.targetInterval;
            const now = Date.now();
            const updateTime = now - currentTime;
            if (updateTime > this.targetInterval * this.UPDATE_LOAD_COEFF) {
                // overloaded
                if (this.prevTime < now - this.targetInterval) {
                    // do not accumulate too much
                    this.prevTime = now - this.targetInterval;
                }
                break;
            }
        }

        if (updated) {
            if(this.enterframeTarget) this.enterframeTarget.enterframeThinOut();
            if(this.pack.loading) this.pack.loading.enterframeThinOut();
            if(this.pack.transition) this.pack.transition.enterframeThinOut();
        }

        if(this.enterframeIgnoreCnt % 90 === 0){
            //間引き処理(1 execution per 90 frames)
            this.resizeHandler();
        }

        //前回のスクロール位置（全ての処理が終わってから代入）
        this.pastPageYOffset = this.pack.pastScrollY = this.pack.scrollY;

        this.enterframeIgnoreCnt++;
    }

    enterframeThinOut(){

    }

    reload(){
        location.reload(false);
    }

    executeResize() {
        super.executeResize();
        if(this.isPc === undefined){
            if(this.sw >= this.pack.BP) this.isPc = true;
            else this.isPc = false;
        }else{
            if(this.sw >= this.pack.BP){
                if(!this.isPc) this.reload();
            }else{
                if(this.isPc) this.reload();
            }
        }

        this.updateFixedEntryButton(true);
    }

    clearFixedEntryFadingTimer(){
        if(this.fixedEntryFadingTimer === null) return;
        window.clearTimeout(this.fixedEntryFadingTimer);
        this.fixedEntryFadingTimer = null;
    }

    shouldShowFixedEntryButton(namespace){
        return namespace !== 'top' && namespace !== 'page404' && namespace !== 'entry';
    }

    removeFixedEntryButton(){
        const entryBtnDOMs = document.querySelectorAll('.entry_btn.js-fixed-entry-btn');
        entryBtnDOMs.forEach((entryBtnDOM) => {
            entryBtnDOM.remove();
        });
    }

    ensureFixedEntryButton(){
        const entryBtnDOMs = document.querySelectorAll('.entry_btn.js-fixed-entry-btn');
        if(entryBtnDOMs.length > 0){
            entryBtnDOMs.forEach((entryBtnDOM, index) => {
                if(index > 0) entryBtnDOM.remove();
            });
            return entryBtnDOMs[0];
        }

        const scrollWrapperDOM = document.querySelector('.scroll-wrapper');
        if(!scrollWrapperDOM) return null;

        const entryBtnDOM = document.createElement('div');
        entryBtnDOM.className = 'entry_btn js-fixed-entry-btn';

        const anchorDOM = document.createElement('a');
        anchorDOM.className = 'no-barba';
        anchorDOM.href = '/recruit/entry/';

        const labelDOM = document.createElement('span');
        labelDOM.textContent = 'ENTRY';

        anchorDOM.appendChild(labelDOM);
        entryBtnDOM.appendChild(anchorDOM);

        const footerDOM = scrollWrapperDOM.querySelector('footer');
        if(footerDOM){
            scrollWrapperDOM.insertBefore(entryBtnDOM, footerDOM);
        }else{
            scrollWrapperDOM.appendChild(entryBtnDOM);
        }

        return entryBtnDOM;
    }

    updateFixedEntryButton(forceUpdate = false){
        const namespace = this.pack.current || '';
        if(!this.shouldShowFixedEntryButton(namespace)){
            this.clearFixedEntryFadingTimer();
            this.removeFixedEntryButton();
            this.fixedEntryIsSmall = false;
            return;
        }

        const entryBtnDOM = this.ensureFixedEntryButton();
        if(!entryBtnDOM){
            this.clearFixedEntryFadingTimer();
            this.fixedEntryIsSmall = false;
            return;
        }

        const shouldSmall = window.scrollY > this.fixedEntrySmallThreshold;

        if(shouldSmall !== this.fixedEntryIsSmall || forceUpdate){
            if(shouldSmall){
                entryBtnDOM.classList.add('fading');
                this.clearFixedEntryFadingTimer();
                this.fixedEntryFadingTimer = window.setTimeout(() => {
                    const currentEntryBtnDOM = document.querySelector('.entry_btn.js-fixed-entry-btn');
                    if(!currentEntryBtnDOM) return;
                    currentEntryBtnDOM.classList.remove('fading');
                    currentEntryBtnDOM.classList.add('small');
                }, 100);
            }else{
                this.clearFixedEntryFadingTimer();
                entryBtnDOM.classList.remove('fading');
                entryBtnDOM.classList.remove('small');
            }

            this.fixedEntryIsSmall = shouldSmall;
        }

        const footerDOM = document.querySelector('footer');
        if(!footerDOM){
            entryBtnDOM.classList.remove('fade_out');
            return;
        }

        const btnRect = entryBtnDOM.getBoundingClientRect();
        const footerRect = footerDOM.getBoundingClientRect();
        const overlaps = btnRect.bottom > footerRect.top;
        entryBtnDOM.classList.toggle('fade_out', overlaps);
    }
}
